import { useCart } from "@/lib/cart";
import { Link } from "react-router-dom";
import { Reveal } from "./motion";

export function SectionHeading({ eyebrow, title, desc, align = "left", dark = false, eyebrowClassName = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left";
  return (
    <Reveal className={`max-w-3xl ${alignCls}`}>
      <p className={`eyebrow ${dark ? "!text-brandlight" : ""} ${eyebrowClassName}`}>{eyebrow}</p>
      <h2 className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-[1.15] ${dark ? "text-ivory" : "text-ink"}`}>
        {title}
      </h2>
      {desc && <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-ivory/70" : "text-slate-600"}`}>{desc}</p>}
    </Reveal>
  );
}

export function CourseCard({ course, onOpen, index = 0 }) {
  const { has, add, remove } = useCart();
  const inCart = has(course.code);
  return (
    <Reveal delay={(index % 4) * 0.07} className="h-full">
      <div className="group card-line flex h-full w-full flex-col p-7 transition-all duration-300 hover:-translate-y-1 hover:border-brand/40 hover:shadow-xl hover:shadow-brand/10">
        <div
          role="button"
          tabIndex={0}
          data-testid={`course-card-${course.code}`}
          onClick={() => onOpen(course)}
          onKeyDown={(e) => { if (e.key === "Enter") onOpen(course); }}
          className="block w-full cursor-pointer text-left"
        >
          <div className="flex items-start justify-between gap-3">
            <span className="rounded-lg bg-ink px-2.5 py-1 font-mono text-xs font-bold tracking-wider text-ivory">
              {course.code}
            </span>
            <span className="font-mono text-xs uppercase tracking-widest text-slate-400">Grade {course.grade}</span>
          </div>
          <h3 className="mt-4 font-display text-lg font-semibold text-ink leading-snug group-hover:text-brand transition-colors">
            {course.name}
          </h3>
          <p className="mt-1 text-xs font-semibold uppercase tracking-wider text-aqua">{course.level} · {course.discipline}</p>
          <p className="mt-3 text-sm leading-relaxed text-slate-600 line-clamp-3">{course.desc}</p>
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); onOpen(course); }}
            data-testid={`course-details-btn-${course.code}`}
            className="mt-2 self-start text-xs font-bold text-brand transition-colors hover:text-brandlight"
          >
            Details →
          </button>
        </div>
        <div className="mt-auto flex items-center justify-between gap-2 border-t border-slate-100 pt-4">
          <span className="font-mono text-sm font-bold text-ink">
            ${course.price.domestic}
            <span className="ml-1 text-xs font-normal text-slate-400">/credit</span>
          </span>
          <button
            type="button"
            onClick={() => (inCart ? remove(course.code) : add(course.code))}
            data-testid={`course-cart-${course.code}`}
            className={`rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${
              inCart ? "bg-aqualight text-aqua" : "bg-ink text-ivory hover:bg-brand"
            }`}
          >
            {inCart ? "✓ In cart" : "+ Add to cart"}
          </button>
        </div>
      </div>
    </Reveal>
  );
}
